import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import User from "@/model/user";

@Module({ namespaced: true })
export default class UserModule extends VuexModule {
  public user: User = null;

  @Mutation
  set(user: User): void {
    this.user = user;
  }
  @Mutation
  deleteCooperate(index: number): void {
    this.user.user_companies.splice(index, 1);
  }

  @Action({ rawError: true })
  setUser(user: User) {
    this.context.commit("set", user);
  }

  @Action({ rawError: true })
  clear() {
    this.context.commit("set", null);
  }

  @Action({ rawError: true })
  spliceCooperate(index: number): void {
    this.context.commit("deleteCooperate", index);
  }
}